module.exports = "<a class=\"ui-card padding-md card-hoverable\"\r\n    ui-sref=\"empresa({empresa_id: $ctrl.data.empresa_id})\">\r\n  <div class=\"flex-align-center kd-item kd-item--large\">\r\n    <div class=\"flex nobreak\">\r\n      <div class=\"--text-bold\">{{::$ctrl.data.nombre}}</div>\r\n      <div ng-if=\"::$ctrl.data.rfc\">\r\n        RFC: {{::$ctrl.data.rfc}}\r\n      </div>\r\n      <div ng-if=\"::!$ctrl.data.rfc\">\r\n        RFC NO REGISTRADO\r\n      </div>\r\n    </div>\r\n  </div>\r\n</a>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/empresas/components/lista/item/template.html
// module id = 2444
// module chunks = 0